import { render, staticRenderFns } from "./VentureStages.vue?vue&type=template&id=2a970c1e&scoped=true"
import script from "./VentureStages.vue?vue&type=script&lang=js"
export * from "./VentureStages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a970c1e",
  null
  
)

export default component.exports